module.exports = __webpack_public_path__ + "img/success.abbaba78.png";